document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('starry-header-three_nav-menu')) {
      customElements.define(
        'starry-header-three_nav-menu',
        class StarryHeaderThreeNavMenu extends HTMLElement {
          constructor() {
            super();
            this.currentActiveIndex = 1;
            this.isHovering = false; // 判断是否有菜单项或按钮在悬停
          }

          connectedCallback() {
            this.init();
            this.setupButtons();
            // 默认展示第一个按钮
            this.showButtonByIndex(this.currentActiveIndex);
          }

          init() {
            // 触发器 hover 事件注册
            const containerEle = this.querySelector('.starry_three_nav_container');
            const triggerEler = this.querySelector('.starry_nav_trigger');
            containerEle.addEventListener('mouseenter', () => {
              triggerEler.setAttribute('data-active', true);
            });
            containerEle.addEventListener('mouseleave', () => {
              triggerEler.removeAttribute('data-active');
            });

            // 产品菜单 hover 事件注册
            this.handleThreeNavListActive(this.currentActiveIndex, true);
            const menuEleList = this.querySelectorAll('.starry_three_nav_menu_item');
            menuEleList.forEach((eleItem) => {
              eleItem.addEventListener('mouseenter', () => {
                if (this.currentActiveIndex > 0) {
                  this.querySelector(
                    `.starry_three_nav_menu_item[data-index="${this.currentActiveIndex}"]`
                  ).setAttribute('data-active', false);
                  this.handleThreeNavListActive(this.currentActiveIndex, false);
                }
                const activeIndex = eleItem.dataset.index;
                eleItem.setAttribute('data-active', true);
                this.handleThreeNavListActive(activeIndex, true);
                this.currentActiveIndex = activeIndex;
              });
            });
          }

          handleThreeNavListActive(index, isActive = false) {
            const listEle = this.querySelector(`.starry_three_nav_list[data-index="${index}"]`);
            if (isActive) {
              listEle.style.display = 'grid';
              setTimeout(() => {
                listEle.style.opacity = 1;
                listEle.style.transform = 'translateX(0)';
              }, 1);
            } else {
              listEle.style.display = 'none';
              listEle.style.opacity = 0;
              listEle.style.transform = 'translateX(-20px)';
            }
          }

          setupButtons() {
            this.buttons = this.querySelectorAll('.view_all_button');
            const menuItems = this.querySelectorAll('.starry_three_nav_menu_item');

            // 隐藏所有按钮的函数
            const hideAllButtons = () => {
              this.buttons.forEach((button) => (button.style.display = 'none'));
            };

            // 显示特定索引的按钮的函数
            this.showButtonByIndex = (index) => {
              hideAllButtons();
              const targetButton = this.querySelector(`.view_all_button[data-index="${index}"]`);
              if (targetButton) {
                targetButton.style.display = 'flex';
              }
            };

            // 处理菜单项悬停事件
            menuItems.forEach((item) => {
              item.addEventListener('mouseenter', () => {
                const targetIndex = item.getAttribute('data-index');
                this.isHovering = true;
                this.showButtonByIndex(targetIndex);
              });

              item.addEventListener('mouseleave', () => {
                setTimeout(() => {
                  if (!this.isHovering) {
                    hideAllButtons();
                  }
                }, 200); // 延迟时间可根据需要调整
              });
            });
          }
        }
      );
    }
  });